(() => {
  const SECTION_SELECTOR = '.mt-kj-project-contact-form[data-section-id]';

  const initSection = (section) => {
    if (!section || section.dataset.mtKjProjectContactFormInitialized === 'true') {
      return;
    }

    section.dataset.mtKjProjectContactFormInitialized = 'true';
  };

  const initAllSections = (container = document) => {
    container.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSections());
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllSections(event.target);
  });
})();
